import { Injectable } from '@angular/core';
import {
  GraphComponent,
  HierarchicalLayout,
  HierarchicalLayoutData,
  LayoutExecutor,
} from '@yfiles/yfiles';
import { BranchRegion } from '../models/business-process.model';
const LAYOUT_TIME_LIMIT = '5s';
// the user's configured direction (its values are yFiles's own orientation names)
export type BusinessProcessLayoutOrientation =
  | 'top-to-bottom'
  | 'bottom-to-top'
  | 'left-to-right'
  | 'right-to-left';
@Injectable({ providedIn: 'root' })
export class BusinessProcessLayoutService {
  async applyInitialLayout(
    gc: GraphComponent,
    regions: readonly BranchRegion[],
    o: BusinessProcessLayoutOrientation = 'top-to-bottom',
  ) {
    await this.apply(gc, regions, o, false);
  }
  async applyAnimatedLayout(
    gc: GraphComponent,
    regions: readonly BranchRegion[],
    o: BusinessProcessLayoutOrientation = 'top-to-bottom',
  ) {
    await this.apply(gc, regions, o, true);
  }
  private async apply(
    gc: GraphComponent,
    regions: readonly BranchRegion[],
    o: BusinessProcessLayoutOrientation,
    animated: boolean,
  ) {
    const layout = new HierarchicalLayout({
      layoutOrientation: o,
      minimumLayerDistance: 90,
      nodeDistance: 55,
      nodeToEdgeDistance: 30,
      edgeDistance: 18,
      // large organisations have thousands of steps: past this the layout takes quicker options rather than
      // keeping the page waiting (one of 4,000 steps took a minute)
      stopDuration: LAYOUT_TIME_LIMIT,
    });
    const layoutData = new HierarchicalLayoutData();
    void regions;
    const executor = new LayoutExecutor({
      graphComponent: gc,
      layout,
      layoutData,
      animationDuration: animated ? '0.45s' : '0s',
      animateViewport: animated,
    });
    await executor.start();
  }
}
